import { IProduct } from "../types/product-d-t";

const product_data: IProduct[] = [
]

export default product_data;
